import { upsertFile } from '@commenda/api/document/createDocument';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  FieldWrapper,
  Label,
  LoadingIndicator,
  SingleFileUploader,
} from '@commenda/kakashi';
import { IDocument } from '@commenda/types/src/drive-view/types';
import { FileBasic } from '@commenda/types/src/file/types';
import { LegacyDocumentType } from '@prisma/client';
import { Dispatch, SetStateAction, useState } from 'react';
import { Accept } from 'react-dropzone';

type FileUploadModalProps = {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  file: FileBasic;
  setFile: Dispatch<SetStateAction<FileBasic>>;
  documentType: LegacyDocumentType;
  title: string;
  onUploadSuccess?: () => void;
  accept?: Accept;
  corporationId: number;
  uploadedDocument: IDocument;
  companyId: number;
};

export const FileUploadModal = ({
  isOpen,
  setIsOpen,
  file,
  setFile,
  corporationId,
  documentType,
  onUploadSuccess,
  title = 'Upload file',
  accept,
  uploadedDocument,
  companyId,
}: FileUploadModalProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const upload = async () => {
    setIsSubmitting(true);
    await upsertFile({
      corporationId,
      documentType,
      fileId: uploadedDocument?.id,
      fileUrl: file.fileUrl,
      fileName: file.fileName,
    });

    if (onUploadSuccess) onUploadSuccess();
    setIsSubmitting(false);
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="flex flex-col">
        <DialogHeader className="flex flex-col items-start">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>
            Please upload only a CSV, PDF, or Excel file.
          </DialogDescription>
        </DialogHeader>
        <div className="p-6">
          <FieldWrapper>
            <Label>
              Upload file
              <span className="text-utility-violet-600">*</span>
            </Label>
            <SingleFileUploader
              companyId={companyId}
              file={
                file
                  ? {
                      fileName: file?.fileName,
                      fileUrl: file?.fileUrl,
                      documentType,
                    }
                  : undefined
              }
              accept={accept}
              setFile={setFile}
              token={undefined}
            />
          </FieldWrapper>
        </div>
        <DialogFooter className="w-full">
          <Button
            variant="secondary"
            onClick={() => setIsOpen(false)}
            className="flex items-center gap-2"
          >
            Cancel
          </Button>

          <Button
            onClick={upload}
            disabled={isSubmitting || !file?.fileUrl}
            className="flex items-center gap-2"
          >
            {isSubmitting ? <LoadingIndicator /> : null} <span>Confirm</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
